import {createAction, createReducer} from 'redux-act';
import {AxiosPromise} from 'axios';
import {FULFILLED} from 'redux-promise-middleware';

import {ENDPOINTS} from 'constants/endpoints';
import {API_URL} from 'constants/api';
import {ApplicationStoreType} from 'reducers';
import {instanceGusaBackend} from 'libs/api';

export type ReviewType = {
    id: number;
    productId: number;
    statusId: number;
    createdAt: string;
    title: string;
    author: {
        nickname: string;
    };
    detail: string;
    recommend: null;
    website: number;
    photos: Array<string>;
    overall: number;
    quality: number;
    fit: number;
    style: number;
};

export type ReviewsType = {
    items: ReviewType[];
    total_score: TotalScoreType;
};

export type TotalScoreType = {
    count: number;
    value: number;
};

export const initialState: ReviewsType = {
    items: [],
    total_score: {count: 0, value: 0},
};

/**
 * List of actions
 */
export const fetchReviews = createAction<
    AxiosPromise<{
        items: ReviewType[];
        total_score: TotalScoreType;
    }>
>('FETCH_REVIEWS', (productId, limit = 8) =>
    instanceGusaBackend({
        method: 'get',
        url: ENDPOINTS.FETCH_REVIEWS,
        baseURL: API_URL,
        params: {
            productId,
            limit,
            'order[random]': '',
        },
    }),
);

/**
 * review reducer
 */
export const reviews = createReducer<ReviewsType>({}, initialState).on(
    `${fetchReviews}_${FULFILLED}`,
    (state, {data}) => ({
        ...state,
        ...data,
    }),
);

/**
 * get reviews
 * @param {ApplicationStoreType} store - ApplicationStoreType
 * @returns {ReviewsType} - initial state
 */
export const getReviews = (store: ApplicationStoreType): ReviewsType => store.contactsPdp.reviews;

/**
 * get reviews items
 * @param {ApplicationStoreType} store - ApplicationStoreType
 * @returns {Array<ReviewType>} - list reviews
 */
export const getReviewsItems = (store: ApplicationStoreType): ReviewType[] =>
    getReviews(store).items;

/**
 * get total score of reviews
 * @param {ApplicationStoreType} store - ApplicationStoreType
 * @returns {TotalScoreType} - total score
 */
export const getTotalScore = (store: ApplicationStoreType): TotalScoreType =>
    getReviews(store).total_score;
